/** Broj spojene pošiljke (interno: meta narudžba): id 1024 ↔ "S-1024". */
export function formatMetaNumber(id: number): string {
  return `S-${id}`;
}

/** Tolerantno: "S-1024", "s 1024", "S'1024", "S1024" → 1024; stari prefiks "M-1024" (već štampane naljepnice) također. */
export function parseMetaNumber(input: string): number | null {
  const m = /^[SM][^A-Z0-9]?(\d{1,9})$/i.exec(input.trim());
  return m ? Number(m[1]) : null;
}
